<script>
import AppDropFile from "../../geral/AppDropFile/AppDropFile.vue";
import certificadosDigitais from "../../../api/certificados-digitais";

export default {
  name: "AdicionarCertificadoDigitalModal",
  components: {AppDropFile},
  props: {
    visible: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      closeButton: false,
      loading: false,
      form: {
        senha: '',
        certificado: null,
        error: ''
      }
    }
  },
  computed: {
    formInvalido() {
      return this.form.certificado === null || !this.form.senha.length || this.arquivoInvalido;
    },
    formFileDisabilitado() {
      return this.form.certificado !== null;
    },
    arquivoInvalido() {
      return this.form.certificado !== null && this.form.certificado.type !== 'application/x-pkcs12';
    }
  },
  methods: {
    fecharModal() {
      this.form.senha = '';
      this.form.error = '';
      this.form.certificado = null;
      this.$emit("closeModal");
    },
    onSubmit() {
      if(this.arquivoInvalido) {
        return;
      } else {
        this.form.error = '';
      }

      this.loading = true;
      this.closeButton = true;

      const formData = new FormData();
      formData.append('senha', this.form.senha);
      formData.append('certificado', this.form.certificado);

      certificadosDigitais.criar(formData)
        .then(() => {
          this.form.error = '';
          window.location.reload();
        })
        .catch(({ response }) => {
          if (response && response.data && response.data.error) {
            this.form.error = response.data.error;
          } else {
            this.form.error = 'Ocorreu um erro ao processar sua solicitação.';
          }
        })
        .finally(() => {
          this.loading = false;
          this.closeButton = false;
        });
    },
    onFileChange(files) {
      if (files.length === 0) {
        this.form.certificado = null;
        this.form.error = '';
      } else {
        if (files[0].type !== 'application/x-pkcs12') {
          this.form.error = 'Arquivo inválido! Por favor, faça upload de um arquivo .pfx.'
        } else {
          this.form.error = '';
        }
        this.form.certificado = files[0];
      }
    },
  }
}
</script>

<template>
  <div>
    <modal
        size="small"
        ref="modal"
        :hideCloseButton="closeButton"
        v-if="visible"
        @close-modal="fecharModal"
      >
        <div slot="header">
          Registre um Certificado Digital
        </div>
        <div class="container" slot="content">
          <p>
            Forneça o certificado/arquivo .pfx e a senha
            para registrar seus certificados digitais da OAB.
          </p>
          <form id="form-certificado" @submit.prevent="onSubmit" @keydown.enter.prevent="onSubmit">
            <AppDropFile
              @change="onFileChange"
              accept=".pfx"
              :multiple="false"
              :disable="formFileDisabilitado"
            />

            <div class="form-box form-creditos">
              <label class="label">Senha</label>
              <input
                class="field name-w"
                type="password"
                name="senha"
                required="required"
                v-model="form.senha"
                autocomplete="off"
              />
            </div>
            <span class="Message -fail" v-text="this.form.error"></span>
            <Btn
              class="btn certificado-button"
              type="submit"
              :loading="loading"
              :disabled="loading || formInvalido"
              @click="onSubmit"
            >
              <b>Adicionar</b>
            </Btn>
          </form>
        </div>
        <div slot="footer"></div>
      </modal>
  </div>

</template>

<style scoped lang="stylus">
#form-certificado
  display flex
  flex-direction column

.certificado-button
  background-color #2393ae
  color #fff
  font-size 12px
  border-radius 5px
  font-weight 500
  padding 20px 40px
  width 35%
  margin-top 10px

.certificado-button:hover
  opacity 0.8

.container
   max-width 480px
</style>
